import datadogLogs, { setupDatadog as setupDD } from "@blacknut/logging-datadog/dist";
import { State } from "core";
import { useSelector } from "react-redux";

export const setupDatadog = () => {
  const appVersion = process.env.REACT_APP_DD_VERSION || "0.0.0.NA";
  setupDD({
    service: "client",
    version: `${appVersion}`,
    env: "prod",
    clientToken: process.env.REACT_APP_DATADOG_TOKEN || "",
  });
};

export const useDatadog = () => {
  const { platform, user } = useSelector((state: State) => state.globalState);
  if (platform && platform.indexOf("api.blacknut.com") !== -1) {
    datadogLogs.setGlobalContextProperty("env", "prod");
    datadogLogs.setGlobalContextProperty("user", { id: user?.id });
  } else if (platform && platform.indexOf("dev") !== -1) {
    datadogLogs.setGlobalContextProperty("env", "dev");
    datadogLogs.setGlobalContextProperty("user", { id: user?.id });
  } else {
    if (platform && platform.indexOf("staging") !== -1) {
      datadogLogs.setGlobalContextProperty("env", "staging");
      datadogLogs.setGlobalContextProperty("user", { id: user?.id });
    }
  }
};
